<template>
  <div class="footer_warp">
    <div class="footer_container">
      <div class="time_box">
        <h3>开馆时间</h3>
        <p style="margin-bottom: 15px">周一至周日</p>
        <h3>国顺院区8:00-22:00</h3>
        <h3>政立院区10:00-20:00</h3>

        <div>
          <p>法定节假日开放时间详见图书馆通知</p>
          <!-- <div class="telUs">
            <svg-icon
              icon-class="phone"
              style="font-size: 20px;vertical-align: middle;"
            />
            <p style="margin-left: 5px;">联系我们</p>
          </div> -->
        </div>
      </div>
      <div class="resource_box">
        <h3>资源</h3>
        <div
          class="link"
          v-for="(item, i) in resourceList"
          :key="i"
          @click="toNav(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="service_box">
        <h3>服务</h3>
        <div
          class="link"
          v-for="(item, i) in serviceList"
          :key="i"
          @click="toNav(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="guide_box">
        <h3>指南</h3>
        <div
          class="link"
          v-for="(item, i) in guideList"
          :key="i"
          @click="toNav(item)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="scan_box">
        <h3>扫一扫</h3>
        <div class="qrcode" style="margin-right: 8px">
          <img src="../../assets/qrcode1.png" alt="" />
          复旦管院图书馆
        </div>
        <!-- <div class="qrcode">
          <img src="../../assets/qrcode2.png" alt="" />
          管图云共读
        </div> -->
      </div>
      <div class="bottom">
        <p>All rights reserved.沪ICP备16018209号-1沪公网安备11010602100083</p>
        <!-- <div style="float: right; display: inline-block">
          <p>关注：</p>
          <div class="icon_box" style="margin-right: 8px">
            <svg-icon icon-class="weibo" />
          </div>
          <div class="icon_box"><svg-icon icon-class="wechat" /></div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { post, get } from "@u/request";
export default {
  name: "",
  components: {},
  props: {
    copyright: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      resourceList: [],
      serviceList: [],
      guideList: [],
    };
  },
  methods: {
    async getNavList() {
      const { data } = await get("lib/menu/list");
      const navList = this.handleTree(data, "id", "pid", "", "status");
      const resourceData = navList.find((item) => item.name === "资源");
      if (resourceData) {
        this.resourceList = resourceData.children;
      }
      const serviceData = navList.find((item) => item.name === "服务");
      if (serviceData) {
        this.serviceList = serviceData.children;
      }
      const guideData = navList.find((item) => item.name === "指南");
      if (guideData) {
        this.guideList = guideData.children;
      }
    },
    toNav(item) {
      if (item.url.toLowerCase().indexOf("http") > -1) {
        window.open(item.url);
      } else if (item.url.indexOf("comPage") > -1) {
        this.$router.push(item.url + "/" + item.id);
      } else if (item.url) {
        this.$router.push(item.url);
      }
    },
  },
  created() {
    this.getNavList();
  },
};
</script>

<style scoped lang="scss">
.footer_warp {
  padding: 30px 0 20px;
  color: #fff;
  background-color: #004796;
  // min-width: 1890px;
  .footer_container {
    width: 1200px;
    margin: 0 auto;

    .bottom {
      width: 100%;
      margin-top: 35px;
      padding-top: 30px;
      border-top: 1px solid #8fb2d4;
      text-align: center;
    }

    h3 {
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 30px;
    }

    p,
    .link {
      display: inline-block;
      font-size: 13px !important;
      color: #fff;
      margin-bottom: 8px;
    }

    .link {
      display: block;
      cursor: pointer;
    }

    .time_box {
      display: inline-block;
      width: 450px;
    }

    .resource_box,
    .service_box,
    .guide_box,
    .scan_box {
      display: inline-block;
      width: 180px;
      text-align: left;
      vertical-align: top;
    }

    .scan_box {
      width: 210px;
    }

    .telUs {
      cursor: pointer;
      display: inline-block;
      width: 140px;
      height: 40px;
      margin-left: 30px;
      border: 1px solid #8badd4;
      text-align: center;
      line-height: 35px;
    }

    .qrcode {
      width: 100px;
      display: inline-block;
      text-align: center;
      font-size: 13px;

      img {
        height: 100px;
        width: 100px;
        margin-bottom: 5px;
      }
    }

    .icon_box {
      cursor: pointer;
      display: inline-block;
      height: 32px;
      width: 32px;
      font-size: 18px;
      text-align: center;
      border-radius: 16px;
      background-color: #4d7fb6;
      vertical-align: middle;
    }
  }
}
</style>
